module.exports = "/legacy/0ac411939c2d06f03f169a1b7f8faf55.png";